import React, { FC } from 'react';
import './_styles.input.css';

interface InputProps {
  placeholder?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement> | undefined;
  onEnded?: React.ChangeEventHandler<HTMLInputElement> | undefined;
  name?: string;
  type?: React.HTMLInputTypeAttribute;
  value?: any;
  className?: string;
  inputRef?: any;
}

const Input: FC<InputProps> = ({
  placeholder,
  onChange,
  name,
  type,
  value,
  onEnded,
  className = '',
  inputRef,
}) => {
  return (
    <input
      onChange={onChange}
      className={`input ${className}`}
      name={name}
      placeholder={placeholder}
      type={type}
      value={value}
      onBlur={onEnded}
      ref={inputRef}
    />
  );
};

export default Input;
